import {
    ADD_SURVEY_WELCOME,
    EDIT_SURVEY_WELCOME,
    LIST_SURVEY_WELCOME,
    VIEW_SURVEY_WELCOME,
    DELETE_SURVEY_WELCOME,

    SURVEY_WELCOME_SUCCESS,
    SURVEY_WELCOME_ERROR,
  
  } from "./actionTypes"
  
  // add SURVEY_WELCOME
  export const addSurveyWelcome = (data, history, callback) => {
    return {
      type: ADD_SURVEY_WELCOME,
      payload: { data, history, callback }
    }
  }
  
  // edit SURVEY_WELCOME
  export const editSurveyWelcome = (data, id, callback) => {
    return {
      type: EDIT_SURVEY_WELCOME,
      payload: { data, id, callback },
    }
  }
  
  // list SURVEY_WELCOME
  export const listSurveyWelcome = (data, callback) => {
    return {
      type: LIST_SURVEY_WELCOME,
      payload: { data, callback },
    }
  }
  
  // view SURVEY_WELCOME
  export const viewSurveyWelcome = (data, history) => {
    return {
      type: VIEW_SURVEY_WELCOME,
      payload: { data, history },
    }
  }
  
  // delete SURVEY_WELCOME
  export const deleteSurveyWelcome = (data, callback) => {
    return {
      type: DELETE_SURVEY_WELCOME,
      payload: { data, callback },
    }
  }
  
  
  export const surveyWelcomeSuccess = message => {
    return {
      type: SURVEY_WELCOME_SUCCESS,
      payload: message,
    }
  }
  
  export const surveyWelcomeError = message => {
    return {
      type: SURVEY_WELCOME_ERROR,
      payload: message,
    }
  }
  